import React from "react";

/**
 * Master v5 Prompt 30C Phase 2 — read-only renderer for the parser's
 * semantic node tree (`{"nodes": [...]}`), shared identically by the
 * coach's import preview and a published static "content" block's live
 * view. Never dangerouslySetInnerHTML — every node type maps to real
 * React elements built from plain-text runs only.
 */
function Runs({ runs }) {
  return (
    <>
      {(runs || []).map((run, i) => {
        let node = run.text;
        if (run.bold) node = <strong key={i}>{node}</strong>;
        if (run.italic) node = <em key={`${i}-i`}>{node}</em>;
        return <React.Fragment key={i}>{node}</React.Fragment>;
      })}
    </>
  );
}

function SemanticNode({ node }) {
  switch (node.type) {
    case "heading_1":
      return <h3 className="text-xl font-semibold text-foreground" data-testid="semantic-heading-1"><Runs runs={node.runs} /></h3>;
    case "heading_2":
      return <h4 className="text-lg font-semibold text-foreground" data-testid="semantic-heading-2"><Runs runs={node.runs} /></h4>;
    case "heading_3":
      return <h5 className="text-base font-semibold text-foreground" data-testid="semantic-heading-3"><Runs runs={node.runs} /></h5>;
    case "bulleted_list":
      return (
        <ul className="list-disc pl-5 space-y-1 text-sm text-foreground/90" data-testid="semantic-bulleted-list">
          {node.items.map((item, i) => <li key={i}><Runs runs={item} /></li>)}
        </ul>
      );
    case "numbered_list":
      return (
        <ol className="list-decimal pl-5 space-y-1 text-sm text-foreground/90" data-testid="semantic-numbered-list">
          {node.items.map((item, i) => <li key={i}><Runs runs={item} /></li>)}
        </ol>
      );
    case "table":
      return (
        <div className="overflow-x-auto rounded-lg border border-border" data-testid="semantic-table">
          <table className="w-full text-sm">
            <tbody>
              {node.rows.map((row, r) => (
                <tr key={r} className="border-b border-border last:border-0">
                  {row.map((cell, c) => (
                    <td key={c} className="px-3 py-2 align-top border-r border-border last:border-0">
                      <Runs runs={cell.runs} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    case "paragraph":
    default:
      if (!node.runs?.length) return null;
      return <p className="text-sm leading-relaxed text-foreground/90"><Runs runs={node.runs} /></p>;
  }
}

export function SemanticContentView({ semanticContent, testId }) {
  const nodes = semanticContent?.nodes || [];
  return (
    <div className="space-y-3" data-testid={testId || "semantic-content-view"}>
      {nodes.map((node, i) => <SemanticNode key={i} node={node} />)}
    </div>
  );
}
